/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * February 2026
 */

import React from 'react';
import {withRouter} from "react-router";
import Row from "react-bootstrap/cjs/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import NbioApi from "../../lib/api/NbioApi";
import BootstrapTable from "react-bootstrap-table-next";
import NPIf from "np-if";
import NPElse from "np-if/src/NPElse";
import Spinner from 'react-bootstrap/Spinner'
import Offcanvas from 'react-bootstrap/Offcanvas';

//components
import CategoryImageUploader from "./CategoryImageUploader";


class CategoriesTable extends React.Component {
    constructor(p) {
        super(p);
        this.state       = {
            categories: [],
            isLoading: true,
            showImageOffcanvas:false,
            selectedCategory: {}
        }
        this.loadCategories         =   this.loadCategories.bind(this);
        this.handleCloseOffcanvas   =   this.handleCloseOffcanvas.bind(this);
        this.onCategoryImageUploaded  =   this.onCategoryImageUploaded.bind(this);
    }

    componentDidMount() {
        this.loadCategories();
    }

    loadCategories = () =>  {
        this.setState({isLoading: true});

        NbioApi.categories.getCategories().then((res) => {
            this.setState({categories:res.data.categories,isLoading:false});
            //this.setState({categories:[{_id:'vitaminasId', name:'vitaminas',image:['']}, {_id:'skinCareID',name:'skin care',image:['']}],isLoading:false});
        }).catch((ex) => {
            this.setState({isLoading:false});
        })
    }

    handleCloseOffcanvas = () =>{
        this.setState({showImageOffcanvas:false,selectedCategory:{}});
    }

    onCategoryImageUploaded = (category) => {
        this.loadCategories();
        this.handleCloseOffcanvas();
    }
    
    render() {
        const columns = [
            {
                dataField: 'name',
                text: 'Nombre',
                formatter:(v,row) =>{
                    return(
                        <div>
                            <a href={`/categories/${row._id}`}>{v}</a>
                        </div>
                    )
                }
            },
            {
                dataField: 'images',
                text: 'Imagen',
                events: {
                    onClick: (e, column, columnIndex, row) => {
                        this.setState({selectedCategory:row,showImageOffcanvas:true})
                    },
                },
                formatter: (value, row) => {
                    let imageObj = value?.length > 0 ? value[0] : {};

                    if (imageObj?.url){
                        return <img className={'img-thumbnail'}
                                    src={imageObj.url}
                                    alt={'Imagen de la categoría'}
                                    width={75}/>
                    }else{
                        return <Button size="sm" variant={'outline-secondary'}>Agregar imagen</Button>
                    }
                },
                headerStyle:(row,rowIndex) =>{
                    return {
                        width:'75px',
                    }
                }
            },
        ];

        return (
            <Container style={{overflowY: "scroll"}} className={'h-100'}>
                <Row>
                    <Col className='py-3 d-flex justify-content-between'>
                        <h5 className={'text-capitalize '}>Categorías</h5>
                        <a href={'/categories/create'}>
                            <Button className={'ml-auto'}>Sincronizar categorías</Button>
                        </a>
                    </Col>
                </Row>

                <Row>
                    <Col className='pb-3'>
                        <NPIf condition={this.state.isLoading}>
                            <div className={'d-flex align-items-center justify-content-center'}>
                                <Spinner animation="grow" variant={"secondary"}/>
                            </div>
                            <NPElse>
                                <BootstrapTable keyField='_id'
                                                data={this.state.categories}
                                                columns={columns}
                                                noDataIndication={`No se encontraron categories`}
                                                bordered={false}
                                />
                            </NPElse>
                        </NPIf>
                    </Col>
                </Row>

                <Offcanvas placement={"end"} show={this.state.showImageOffcanvas} onHide={() => this.handleCloseOffcanvas()}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Agrega la  imagen de la categoría <i>{this.state.selectedCategory.name}</i></Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <CategoryImageUploader category={this.state.selectedCategory} onImageUploaded={() => this.onCategoryImageUploaded} />
                    </Offcanvas.Body>
                </Offcanvas>
            </Container>
        )
    }
}

export default withRouter(CategoriesTable);
